import { EncodeMedium } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { AuditLogReplacement, AuditLogReplacementType } from '../AuditLogReplacement.js';
export class File {
    constructor(data) {
        var _a, _b, _c, _d;
        /// private or not?
        this.isPrivate = false;
        /// signed url if it is a private file
        /// only filled if you have access to this file and when it has a valid signature
        this.signedUrl = null;
        /**
         * A signature that proves that this file was generated by the server and is trusted. Without a valid signature,
         * the backend won't return a signedUrl for accessing the file.
         */
        this.signature = null;
        this.id = data.id;
        this.server = data.server;
        this.path = data.path;
        this.size = data.size;
        this.name = (_a = data.name) !== null && _a !== void 0 ? _a : null;
        this.isPrivate = (_b = data.isPrivate) !== null && _b !== void 0 ? _b : false;
        this.signedUrl = (_c = data.signedUrl) !== null && _c !== void 0 ? _c : null;
        this.signature = (_d = data.signature) !== null && _d !== void 0 ? _d : null;
    }
    getDiffValue() {
        var _a;
        return AuditLogReplacement.create({
            id: this.getPublicPath(),
            value: (_a = this.name) !== null && _a !== void 0 ? _a : undefined,
            type: AuditLogReplacementType.File,
        });
    }
    get signPayload() {
        return 'id: ' + this.id + '\n'
            + 'server: ' + this.server + '\n'
            + 'path: ' + this.path + '\n'
            + 'size: ' + this.size.toFixed(0) + '\n'
            + 'name: ' + this.name + '\n'
            + 'isPrivate: ' + (this.isPrivate ? 'true' : 'false');
    }
    static get signingEnabled() {
        return !!File.signFile;
    }
    async sign() {
        if (!File.signFile) {
            return false;
        }
        await File.signFile(this);
        return true;
    }
    async verify() {
        if (!this.signature) {
            return false;
        }
        if (!File.verifyFile) {
            return false;
        }
        return await File.verifyFile(this);
    }
    async withSignedUrl() {
        if (!this.signature || !this.isPrivate) {
            return null;
        }
        if (!File.getWithSignedUrl) {
            return null;
        }
        if (!await this.verify()) {
            // Never generate a signed url for an untrusted file
            return null;
        }
        return await File.getWithSignedUrl(this);
    }
    static decode(data) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const file = new File({
            id: data.field('id').string,
            server: data.field('server').string,
            path: data.field('path').string,
            size: data.field('size').integer,
            name: (_b = (_a = data.optionalField('name')) === null || _a === void 0 ? void 0 : _a.string) !== null && _b !== void 0 ? _b : null,
            isPrivate: (_d = (_c = data.optionalField('isPrivate')) === null || _c === void 0 ? void 0 : _c.boolean) !== null && _d !== void 0 ? _d : false,
            signedUrl: (_f = (_e = data.optionalField('signedUrl')) === null || _e === void 0 ? void 0 : _e.string) !== null && _f !== void 0 ? _f : null,
            signature: (_h = (_g = data.optionalField('signature')) === null || _g === void 0 ? void 0 : _g.string) !== null && _h !== void 0 ? _h : null,
        });
        if (data.context.medium === EncodeMedium.Database || !file.isPrivate || !file.signature) {
            // Clear signed url that we read from the database - these won't be valid any longer
            file.signedUrl = null;
        }
        if (file.isPrivate && this.signingEnabled && (!data.context.medium || data.context.medium === EncodeMedium.Network)) {
            // A signature is required
            // Because of the sync nature of decoding, we cannot verify it here, but we need to do so when using the file
            if (!file.signature) {
                throw new SimpleError({
                    code: 'missing_signature',
                    message: 'Missing signature for private file',
                });
            }
        }
        return file;
    }
    encode(context) {
        return {
            id: this.id,
            server: this.server,
            path: this.path,
            size: this.size,
            name: this.name,
            isPrivate: this.isPrivate,
            signedUrl: this.isPrivate && this.signedUrl ? this.signedUrl : undefined,
            signature: this.isPrivate ? this.signature : undefined,
        };
    }
    getPublicPath() {
        if (this.signedUrl && this.isPrivate) {
            return this.signedUrl;
        }
        return this.server + '/' + this.path;
    }
}
/**
 * When using public/private keys inside the check functions, you can also only implement the check method
 * to verify signatures received from the backend.
 */
File.verifyFile = null;
File.signFile = null;
File.getWithSignedUrl = null;
//# sourceMappingURL=File.js.map